/**
 * FinList Unified Category System
 * @deprecated This file is DEPRECATED. Import from categorySystem.js instead.
 */

export {
  CATEGORY_TYPES as CATEGORY_SECTIONS,
  EXPENSE_CATEGORIES,
  INCOME_CATEGORIES,
  SAVINGS_CATEGORIES as SAVINGS_GOAL_CATEGORIES,
  BUDGET_ENVELOPES,
  SHOPPING_LIST_CATEGORIES,
  FINTASK_CATEGORIES,
  LEGACY_ID_MAP as AI_CATEGORY_MAPPING,
  getCategoriesByType,
  getExpenseCategoriesForContext, // FINLIST CONTEXT: Filter by context
  findCategoryById,
  getCategoryColor,
  getCategoryEmoji,
  getSubcategories,
  normalizeCategoryId,
} from './categorySystem';

import { 
  EXPENSE_CATEGORIES as _EXPENSE_CATEGORIES,
  INCOME_CATEGORIES as _INCOME_CATEGORIES,
  SAVINGS_CATEGORIES as _SAVINGS_CATEGORIES,
  BUDGET_ENVELOPES as _BUDGET_ENVELOPES,
  SHOPPING_LIST_CATEGORIES as _SHOPPING_CATEGORIES,
  FINTASK_CATEGORIES as _FINTASK_CATEGORIES,
  findCategoryById as _findCategoryById
} from './categorySystem';

// Legacy status exports
export const INCOME_STATUSES = [
  { id: 'pending', name: 'Pending', color: '#f59e0b' },
  { id: 'cleared', name: 'Cleared', color: '#10b981' }
];

export const EXPENSE_STATUSES = [
  { id: 'pending', name: 'Pending', color: '#f59e0b' },
  { id: 'paid', name: 'Paid', color: '#10b981' }
];

export const SHOPPING_ITEM_STATUSES = [
  { id: 'pending', name: 'Pending', color: '#f59e0b' },
  { id: 'bought', name: 'Bought', color: '#10b981' },
  { id: 'refunded', name: 'Refunded', color: '#ef4444' }
];

// Legacy aliases
export const getCategoryById = _findCategoryById;

export function findSubcategory(categoryId, subcategoryId) {
  const category = _findCategoryById(categoryId);
  if (!category || !category.subcategories) return null;
  return category.subcategories.find(sub => sub.id === subcategoryId);
}

export function getLinkedBudgetEnvelope(expenseCategoryId) {
  return _BUDGET_ENVELOPES.find(env => 
    env.linkedExpenseCategories?.includes(expenseCategoryId)
  ) || null;
}

export function getEnvelopeForCategory(categoryId) {
  const envelope = getLinkedBudgetEnvelope(categoryId);
  return envelope?.id || null;
}

export function getStatusOptions(context) {
  switch (context) {
    case 'income': return INCOME_STATUSES;
    case 'expense': return EXPENSE_STATUSES;
    case 'shopping': return SHOPPING_ITEM_STATUSES;
    default: return [];
  }
}

export function getFlatExpenseCategories() {
  const result = [];
  _EXPENSE_CATEGORIES.forEach(cat => {
    result.push({ id: cat.id, name: cat.name, type: 'category', parent: null });
    if (cat.subcategories) {
      cat.subcategories.forEach(sub => {
        result.push({ id: sub.id, name: sub.name, type: 'subcategory', parent: cat.id });
      });
    }
  });
  return result;
}

export function getFlatIncomeCategories() {
  return _INCOME_CATEGORIES.map(cat => ({
    id: cat.id, name: cat.name, type: 'category', parent: null
  }));
}

export function formatForSelect(categories) {
  return categories.map(cat => ({
    value: cat.id, label: cat.name, icon: cat.icon, emoji: cat.emoji, color: cat.color
  }));
}

export function formatForGroupedSelect(categories) {
  return categories.map(cat => ({
    label: cat.name, value: cat.id, emoji: cat.emoji, color: cat.color,
    options: cat.subcategories?.map(sub => ({
      value: sub.id, label: sub.name, parentId: cat.id
    })) || []
  }));
}

export function getCategoriesForModule(module) {
  switch (module) {
    case 'transactions': return [..._EXPENSE_CATEGORIES, ..._INCOME_CATEGORIES];
    case 'transactions-income': return _INCOME_CATEGORIES;
    case 'transactions-expense': return _EXPENSE_CATEGORIES;
    case 'shopping': return _SHOPPING_CATEGORIES;
    case 'tasks':
    case 'fintasks': return _FINTASK_CATEGORIES;
    case 'goals': return _SAVINGS_CATEGORIES;
    case 'budgets': return _BUDGET_ENVELOPES;
    default: return [];
  }
}

import categorySystem from './categorySystem';

export default {
  ...categorySystem,
  CATEGORY_SECTIONS: categorySystem.CATEGORY_TYPES,
  SAVINGS_GOAL_CATEGORIES: categorySystem.SAVINGS_CATEGORIES,
  FINTASK_CATEGORIES: categorySystem.FINTASK_CATEGORIES,
  INCOME_STATUSES,
  EXPENSE_STATUSES,
  SHOPPING_ITEM_STATUSES,
  getCategoryById,
  findSubcategory,
  getLinkedBudgetEnvelope,
  getEnvelopeForCategory,
  getStatusOptions,
  getFlatExpenseCategories,
  getFlatIncomeCategories,
  formatForSelect,
  formatForGroupedSelect,
  getCategoriesForModule
};
